import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { NoDataMessageComponent } from '../components/no-data-message/no-data-message.component';

@Directive({
    selector: '[showWithNoDataMessage]',
    standalone: false
})
export class ShowWithNoDataMessageDirective<T> {
  @Input() set showWithNoDataMessage(isVisible: boolean) {
    this.viewContainer.clear();

    if (isVisible) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.createComponent(NoDataMessageComponent);
    }
  }

  constructor(private templateRef: TemplateRef<T>, private viewContainer: ViewContainerRef) {}
}
